import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

class Header extends Component {

  _onChange = (e) => {
    e.preventDefault();
    const nextTerm = e.target.value;
    this.props.history.push({
      search: '?q=' + nextTerm,
    });
  };

  render() {
    const { query } = this.props;
    return (
        <div className="header">
          <h1><span className="in">in</span>vidia</h1>
          <form onSubmit={this.props.onSubmit}>
            <input type="text" value={query} placeholder="Search anything..." onChange={this._onChange} />
            <button>Search</button>
          </form>
        </div>
    );
  };
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/SearchPage/Header.js